module.exports = __webpack_public_path__ + "check-developer@2x.c092cc22f7195989d702e9e6539178d8.png";